import { Button, Form, SelectBox } from 'devextreme-react';
import { isMobile } from 'react-device-detect';
import { Component } from 'react';
import OrdersBoard from './OrdersBoard';
import LoadOrder from './LoadOrder';

class TestLoadOrder extends Component {
    state = {
        mode: 'board',
    };

    render() {
        return (
            <>
                {this.state.mode === 'edit' &&
                    <LoadOrder loadOrder={this.state.loadOrder} tempCol={this.state.tempCol}
                        onCancel={() => this.setState({ mode: 'board' })}
                    />
                }
                {this.state.mode === 'new' &&
                    <LoadOrder id={0}
                        onCancel={() => this.setState({ mode: 'board' })}
                    />
                }
                {this.state.mode === 'board' &&
                    <OrdersBoard cardWidth={isMobile ? '90vw' : '50rem'} userRole='orderer' //companyId={0}
                        onEdit={(loadOrder, tempCol) => this.setState({ loadOrder, tempCol, mode: 'edit' })}
                        onAddNewOrderClicked={() => this.setState({ mode: 'new' })}
                    />
                }
            </>
        );
    }
}

export default TestLoadOrder;